export default __webpack_public_path__ + "static/media/BCA8.a1d162f1.jpg";